export default __webpack_public_path__ + "static/gatsby_TOC_autolink_headers-17e3ca7610c1f9d51d68a3a4ba47e391.png";